import React from 'react'
import { Button, Flex, useModal } from '@pancakeswap/uikit'
import { useLocation } from 'react-router-dom'
import Page from 'components/PageHeader'
import MoonPayIframe from './MoonFrame'
import MoonPayModal from './MoonpayModal'

const Nem = () => {
  const [onPresentModal] = useModal(<MoonPayModal />)
  const location = useLocation();

  return (
        <Button onClick={() => onPresentModal()} variant="gold" mr="15px" scale="sm" >
          Add Funds
        </Button>
  )
}

export default Nem
